/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('global.ski-resorts')
 */
import Component, { getGuidePageServerSideProps } from 'page-components/global/ski-resorts';
import { propsWithI18NSSR } from 'util/propsWithI18n';

export default Component;
export const getServerSideProps = propsWithI18NSSR(getGuidePageServerSideProps);
